module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz17-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#RR_14",
      "id": "CC_14"
    }
  }, [_vm._v(" Tweeky’s Class Reunion Punch")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pz17-2"
    }
  }, [_c('i', [_vm._v(" Unforgettable. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAz4"
    }
  }, [_c('b', [_vm._v(" 1 large can pineapple juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAuM"
    }
  }, [_c('b', [_vm._v(" 1 quart cranberry juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAyKI"
    }
  }, [_c('b', [_vm._v(" 1 2-liter bottle pale dry ginger ale ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAj7"
    }
  }, [_c('b', [_vm._v(" 2 12-ounce cans frozen orange juice concentrate ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pAvYg"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("F")]), _vm._v("reeze pineapple juice in ring. When frozen, put in bowl with remaining ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAaqh"
    }
  }, [_vm._v(" Makes about 30 punch cups.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pAHPB"
    }
  }, [_c('i', [_vm._v("Diane and Steve McCarty—New Freedom, Pennsylvania")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "pAfIB"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-17-1.jpg",
      "id": "AfIB",
      "src": "images/img-17-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "pAvs"
    }
  }, [_c('i', [_vm._v("Barney “Tweeky” Fife")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "pAcu"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-17-2.jpg",
      "id": "Acu",
      "src": "images/img-17-2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "pAiP"
    }
  }, [_c('i', [_vm._v("NEED GLASSES?—Andy and Barney strain to recognize faces while manning the punch bowl at their high-school class reunion.")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "A8S"
    }
  }, [_c('table', [_c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ERNEST T. BASS:")])]), _vm._v(" "), _c('td', [_vm._v("No coffee, tea, or punch, thank you.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3c0b8cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter14.vue
// module id = 105
// module chunks = 0